module.exports = {"active":{"affidavit":null,"person":null},"affidavits":{},"people":{}}


//////////////////
// WEBPACK FOOTER
// ./src/redux/initialState.json
// module id = 518
// module chunks = 231608221292675